"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _planHelper = require("../../util/planHelper");
var _SubscriptionIconStyled = require("./SubscriptionIconStyled");
var PauseIcon = function PauseIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.675 5.736a2 2 0 0 1 2.422 1.397l.718 2.546a2 2 0 0 0 1.381 1.382l2.546.719a2 2 0 0 1 1.395 2.417l-.65 2.564a2 2 0 0 0 .505 1.887l1.845 1.896a2 2 0 0 1-.002 2.795l-1.846 1.895a2 2 0 0 0-.506 1.888l.65 2.564a2 2 0 0 1-1.396 2.421l-2.546.718a2 2 0 0 0-1.382 1.382l-.72 2.546a2 2 0 0 1-2.416 1.395l-2.564-.652a2 2 0 0 0-1.888.506l-1.896 1.845a2 2 0 0 1-2.795-.002L18.634 38a2 2 0 0 0-1.887-.506l-2.565.65a2 2 0 0 1-2.422-1.397l-.71-2.55a2 2 0 0 0-1.382-1.383l-2.546-.719a2 2 0 0 1-1.395-2.417l.652-2.564a2 2 0 0 0-.506-1.887L4.027 23.33a2 2 0 0 1 .002-2.795l1.844-1.892a2 2 0 0 0 .507-1.887l-.652-2.565a2 2 0 0 1 1.397-2.42l2.546-.719a2 2 0 0 0 1.382-1.381l.72-2.546a2 2 0 0 1 2.416-1.391l2.564.651a2 2 0 0 0 1.888-.506l1.895-1.845a2 2 0 0 1 2.795.002l1.896 1.846a2 2 0 0 0 1.888.506Z",
    fill: "#3550a0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.712 28.857V14.743h4.194v14.114Zm8.243 0V14.743h4.195v14.114Z",
    fill: "#f5f2fd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.45 29.157h-4.795V14.443h4.795Zm-4.194-.6h3.594V15.043h-3.595Zm-4.049.6h-4.795V14.443h4.794Zm-4.194-.6h3.594V15.043h-3.595Z",
    fill: "#3550a0"
  })));
};
PauseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 43.864 43.863"
};
var SubscriptionIcon = function SubscriptionIcon(_ref) {
  var period = _ref.period,
    showLabel = _ref.showLabel,
    className = _ref.className,
    isPaused = _ref.isPaused;
  var _ref2 = _planHelper.periodMapper[period] || _planHelper.periodMapper.default,
    color = _ref2.color,
    bg = _ref2.bg,
    label = _ref2.label,
    border = _ref2.border;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SubscriptionIconStyled.WrapperStyled, {
    color: color || null,
    bg: bg || null,
    border: border || null,
    className: className
  }, showLabel && /*#__PURE__*/_react.default.createElement(_SubscriptionIconStyled.LabelStyled, {
    label: showLabel
  }, showLabel), isPaused ? /*#__PURE__*/_react.default.createElement(PauseIcon, null) : label || ''));
};
SubscriptionIcon.propTypes = {
  period: _propTypes.default.string,
  showLabel: _propTypes.default.string,
  className: _propTypes.default.string,
  isPaused: _propTypes.default.bool
};
SubscriptionIcon.defaultProps = {
  period: 'default',
  showLabel: '',
  className: '',
  isPaused: false
};
var _default = SubscriptionIcon;
exports.default = _default;